function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 2rem 1rem;\n\n  @media (max-width: 768px) {\n    padding: 1rem 0.5rem;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  background: var(--paper, #ffffff);\n  border-radius: 12px;\n  padding: 2rem;\n  margin-bottom: 2rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--text, #1f2937);\n  margin: 0 0 1.5rem 0;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem;\n  border-radius: 8px;\n  cursor: ",
        ";\n  transition: all 0.2s ease;\n  opacity: ",
        ";\n\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  width: 40px;\n  height: 40px;\n  border-radius: 8px;\n  background: var(--paper-light, #f9fafb);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--primary, #3b82f6);\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  font-weight: 500;\n  color: var(--text, #1f2937);\n  margin-bottom: 0.25rem;\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.875rem;\n  color: var(--text-secondary, #6b7280);\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n  flex-wrap: wrap;\n  padding: 1rem;\n  background: var(--paper-light, #f9fafb);\n  border-radius: 8px;\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--text-secondary, #6b7280);\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  padding: 0.5rem;\n  border: 1px solid var(--border, #e5e7eb);\n  border-radius: 6px;\n  background: var(--paper, #ffffff);\n  color: var(--text, #1f2937);\n  font-size: 0.875rem;\n\n  &:focus {\n    outline: none;\n    border-color: var(--primary, #3b82f6);\n  }\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  background: var(--paper, #ffffff);\n  border-radius: 12px;\n  padding: 2rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  display: flex;\n  gap: 1rem;\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  cursor: ",
        ";\n  outline: none;\n  transition: all 0.2s ease-in-out;\n  background: var(--primary, #3b82f6);\n  color: white;\n  font-weight: 500;\n  border-radius: 0.375rem;\n  padding: 0.75rem 1.5rem;\n  flex: 1;\n  gap: 0.5rem;\n  opacity: ",
        ";\n\n  &:hover {\n    background: ",
        ";\n  }\n\n  &:active {\n    transform: ",
        ";\n  }\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--border, #e5e7eb);\n  cursor: pointer;\n  outline: none;\n  transition: all 0.2s ease-in-out;\n  background: transparent;\n  color: var(--text-secondary, #6b7280);\n  font-weight: 500;\n  border-radius: 0.375rem;\n  padding: 0.75rem 1.5rem;\n  flex: 1;\n  gap: 0.5rem;\n\n  &:hover {\n    background: var(--paper-hover, #f3f4f6);\n    border-color: var(--border-light, #d1d5db);\n  }\n\n  &:active {\n    transform: scale(0.98);\n  }\n"
    ]);
    _templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n  color: var(--text-secondary, #6b7280);\n"
    ]);
    _templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n  color: #dc2626;\n"
    ]);
    _templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { useGetNotificationSettings, useUpdateNotificationSettings } from '@edusense/notification-client';
import { NOTIFICATION_TEST_IDS } from '@edusense/shared-constants';
import { Mail, MessageSquare, Bell, BellRing, Clock, Save, X } from 'lucide-react';
// Styled Components - SettingsTemplate 스타일 적용
var TemplateContainer = styled.div(_templateObject());
var SettingsSection = styled.div(_templateObject1());
var SectionTitle = styled.h3(_templateObject2());
var SettingsGrid = styled.div(_templateObject3());
var SettingItemContainer = styled.div(_templateObject4(), function(props) {
    return props.disabled ? 'default' : 'pointer';
}, function(props) {
    return props.disabled ? 0.6 : 1;
}, function(props) {
    return props.disabled ? 'transparent' : 'var(--paper-hover, #f3f4f6)';
});
var SettingItemLeft = styled.div(_templateObject5());
var SettingItemIcon = styled.div(_templateObject6());
var SettingItemContent = styled.div(_templateObject7());
var SettingItemTitle = styled.div(_templateObject8());
var SettingItemDescription = styled.div(_templateObject9());
var SettingItemRight = styled.div(_templateObject10());
var QuietHoursContainer = styled.div(_templateObject11());
var TimeInputWrapper = styled.label(_templateObject12());
var TimeLabel = styled.span(_templateObject13());
var TimeInput = styled.input(_templateObject14());
var ActionSection = styled.div(_templateObject15());
var SaveButton = styled.button(_templateObject16(), function(props) {
    return props.disabled ? 'not-allowed' : 'pointer';
}, function(props) {
    return props.disabled ? 0.5 : 1;
}, function(props) {
    return props.disabled ? 'var(--primary, #3b82f6)' : 'var(--primary-dark, #2563eb)';
}, function(props) {
    return props.disabled ? 'none' : 'scale(0.98)';
});
var CancelButton = styled.button(_templateObject17());
var LoadingContainer = styled.div(_templateObject18());
var ErrorContainer = styled.div(_templateObject19());
/**
 * NotificationSettings Component
 *
 * Displays and manages user notification preferences
 * - Email, SMS, Push, In-App notifications
 * - Quiet hours configuration
 * - Per-type notification settings
 */ export var NotificationSettings = function(param) {
    var userId = param.userId, onClose = param.onClose;
    var _useGetNotificationSettings = useGetNotificationSettings({
        userId: userId
    }, {
        query: {
            enabled: !!userId
        }
    }), settings = _useGetNotificationSettings.data, isLoading = _useGetNotificationSettings.isLoading, refetch = _useGetNotificationSettings.refetch;
    var _useUpdateNotificationSettings = useUpdateNotificationSettings({
        mutation: {
            onSuccess: function() {
                refetch();
                alert('설정이 저장되었습니다.');
            },
            onError: function(error) {
                console.error('설정 저장 실패:', error);
                alert('설정 저장에 실패했습니다.');
            }
        }
    }), updateSettings = _useUpdateNotificationSettings.mutate, isPending = _useUpdateNotificationSettings.isPending;
    var _useState = _sliced_to_array(useState(settings !== null && settings !== void 0 ? settings : null), 2), localSettings = _useState[0], setLocalSettings = _useState[1];
    useEffect(function() {
        if (settings) {
            setLocalSettings(settings);
        }
    }, [
        settings
    ]);
    var handleToggle = function(key) {
        if (!localSettings) return;
        setLocalSettings(_object_spread_props(_object_spread({}, localSettings), _define_property({}, key, !localSettings[key])));
    };
    var handleTypeToggle = function(type) {
        if (!(localSettings === null || localSettings === void 0 ? void 0 : localSettings.typeSettings)) return;
        setLocalSettings(_object_spread_props(_object_spread({}, localSettings), {
            typeSettings: _object_spread_props(_object_spread({}, localSettings.typeSettings), _define_property({}, type, !localSettings.typeSettings[type]))
        }));
    };
    var handleSave = function() {
        if (!localSettings) return;
        updateSettings({
            userId: userId,
            data: {
                userId: localSettings.userId,
                emailEnabled: localSettings.emailEnabled,
                smsEnabled: localSettings.smsEnabled,
                pushEnabled: localSettings.pushEnabled,
                inAppEnabled: localSettings.inAppEnabled,
                quietHoursStart: localSettings.quietHoursStart,
                quietHoursEnd: localSettings.quietHoursEnd,
                frequency: localSettings.frequency,
                typeSettings: localSettings.typeSettings
            }
        });
    };
    if (isLoading) {
        return /*#__PURE__*/ React.createElement(LoadingContainer, {
            "data-testid": NOTIFICATION_TEST_IDS.NOTIFICATION_SETTINGS_LOADING
        }, "설정을 불러오는 중...");
    }
    if (!localSettings) {
        return /*#__PURE__*/ React.createElement(ErrorContainer, {
            "data-testid": NOTIFICATION_TEST_IDS.NOTIFICATION_SETTINGS_ERROR
        }, "설정을 불러올 수 없습니다.");
    }
    // 알림 채널 설정 항목
    var channelSettings = [
        {
            key: 'emailEnabled',
            icon: Mail,
            title: '이메일 알림',
            description: '이메일로 알림 받기',
            testId: NOTIFICATION_TEST_IDS.NOTIFICATION_SETTINGS_EMAIL
        },
        {
            key: 'smsEnabled',
            icon: MessageSquare,
            title: 'SMS 알림',
            description: '문자 메시지로 알림 받기',
            testId: NOTIFICATION_TEST_IDS.NOTIFICATION_SETTINGS_SMS
        },
        {
            key: 'pushEnabled',
            icon: Bell,
            title: '푸시 알림',
            description: '푸시 알림으로 알림 받기',
            testId: NOTIFICATION_TEST_IDS.NOTIFICATION_SETTINGS_PUSH
        },
        {
            key: 'inAppEnabled',
            icon: BellRing,
            title: '인앱 알림',
            description: '앱 내에서 알림 받기',
            testId: NOTIFICATION_TEST_IDS.NOTIFICATION_SETTINGS_IN_APP
        }
    ];
    return /*#__PURE__*/ React.createElement(TemplateContainer, {
        "data-testid": NOTIFICATION_TEST_IDS.NOTIFICATION_SETTINGS_CONTAINER
    }, /*#__PURE__*/ React.createElement(SettingsSection, null, /*#__PURE__*/ React.createElement(SectionTitle, null, /*#__PURE__*/ React.createElement(Bell, {
        size: 20
    }), "알림 채널"), /*#__PURE__*/ React.createElement(SettingsGrid, null, channelSettings.map(function(setting) {
        return /*#__PURE__*/ React.createElement(SettingItemContainer, {
            key: setting.key,
            onClick: function() {
                return handleToggle(setting.key);
            },
            "data-testid": setting.testId
        }, /*#__PURE__*/ React.createElement(SettingItemLeft, null, /*#__PURE__*/ React.createElement(SettingItemIcon, null, /*#__PURE__*/ React.createElement(setting.icon, {
            size: 20
        })), /*#__PURE__*/ React.createElement(SettingItemContent, null, /*#__PURE__*/ React.createElement(SettingItemTitle, null, setting.title), /*#__PURE__*/ React.createElement(SettingItemDescription, null, setting.description))), /*#__PURE__*/ React.createElement(SettingItemRight, null, /*#__PURE__*/ React.createElement("input", {
            type: "checkbox",
            checked: Boolean(localSettings[setting.key]),
            onChange: function() {
                return handleToggle(setting.key);
            },
            className: "w-5 h-5 cursor-pointer"
        })));
    }))), localSettings.typeSettings && Object.keys(localSettings.typeSettings).length > 0 && /*#__PURE__*/ React.createElement(SettingsSection, null, /*#__PURE__*/ React.createElement(SectionTitle, null, /*#__PURE__*/ React.createElement(BellRing, {
        size: 20
    }), "알림 타입"), /*#__PURE__*/ React.createElement(SettingsGrid, null, Object.entries(localSettings.typeSettings).map(function(param) {
        var _param = _sliced_to_array(param, 2), type = _param[0], enabled = _param[1];
        return /*#__PURE__*/ React.createElement(SettingItemContainer, {
            key: type,
            onClick: function() {
                return handleTypeToggle(type);
            },
            "data-testid": "".concat(NOTIFICATION_TEST_IDS.NOTIFICATION_SETTINGS_TYPE_PREFIX).concat(type.toLowerCase())
        }, /*#__PURE__*/ React.createElement(SettingItemLeft, null, /*#__PURE__*/ React.createElement(SettingItemIcon, null, /*#__PURE__*/ React.createElement(Bell, {
            size: 20
        })), /*#__PURE__*/ React.createElement(SettingItemContent, null, /*#__PURE__*/ React.createElement(SettingItemTitle, null, type), /*#__PURE__*/ React.createElement(SettingItemDescription, null, type, " 알림 받기"))), /*#__PURE__*/ React.createElement(SettingItemRight, null, /*#__PURE__*/ React.createElement("input", {
            type: "checkbox",
            checked: enabled,
            onChange: function() {
                return handleTypeToggle(type);
            },
            className: "w-5 h-5 cursor-pointer"
        })));
    }))), /*#__PURE__*/ React.createElement(SettingsSection, null, /*#__PURE__*/ React.createElement(SectionTitle, null, /*#__PURE__*/ React.createElement(Clock, {
        size: 20
    }), "조용한 시간"), /*#__PURE__*/ React.createElement(QuietHoursContainer, null, /*#__PURE__*/ React.createElement(TimeInputWrapper, null, /*#__PURE__*/ React.createElement(TimeLabel, null, "시작 시간"), /*#__PURE__*/ React.createElement(TimeInput, {
        type: "time",
        value: localSettings.quietHoursStart || '',
        onChange: function(e) {
            return setLocalSettings(_object_spread_props(_object_spread({}, localSettings), {
                quietHoursStart: e.target.value
            }));
        },
        "data-testid": NOTIFICATION_TEST_IDS.NOTIFICATION_SETTINGS_QUIET_START
    })), /*#__PURE__*/ React.createElement(TimeInputWrapper, null, /*#__PURE__*/ React.createElement(TimeLabel, null, "종료 시간"), /*#__PURE__*/ React.createElement(TimeInput, {
        type: "time",
        value: localSettings.quietHoursEnd || '',
        onChange: function(e) {
            return setLocalSettings(_object_spread_props(_object_spread({}, localSettings), {
                quietHoursEnd: e.target.value
            }));
        },
        "data-testid": NOTIFICATION_TEST_IDS.NOTIFICATION_SETTINGS_QUIET_END
    })))), /*#__PURE__*/ React.createElement(ActionSection, null, /*#__PURE__*/ React.createElement(SaveButton, {
        onClick: handleSave,
        disabled: isPending,
        "data-testid": NOTIFICATION_TEST_IDS.NOTIFICATION_SETTINGS_SAVE_BUTTON
    }, /*#__PURE__*/ React.createElement(Save, {
        size: 16
    }), isPending ? '저장 중...' : '저장'), onClose && /*#__PURE__*/ React.createElement(CancelButton, {
        onClick: onClose,
        "data-testid": NOTIFICATION_TEST_IDS.NOTIFICATION_SETTINGS_CANCEL_BUTTON
    }, /*#__PURE__*/ React.createElement(X, {
        size: 16
    }), "취소")));
};
export default NotificationSettings;
